import { TelegramPersonalCloudPasswordExternal } from '@/features/channels';

interface IProps {
  id: string;
  refetch: () => void;
}

export const TGExternalPasswordRenderer = ({ id, refetch }: IProps) => {
  return (
    <TelegramPersonalCloudPasswordExternal
      channelId={id ?? ''}
      onSuccess={refetch}
    />
  );
};
